import { createAction } from 'redux-act';
import { put } from 'redux-saga/effects';

export function* failed(action) {
  yield put({
    type: `${action().type}_FAILED`,
  });
}

export function* succeeded(action, args) {
  yield put({
    type: `${action().type}_SUCCEEDED`,
    payload: args,
  });
}

export function startLoadingAction(actionName, loader, message, globalLoading = false) {
  return createAction(actionName, args => args, (() => ({
    loading: true,
    loader,
    message,
    global: globalLoading,
  })));
}

export function endLoadingAction(actionName, loader, message, stopLoading) {
  return createAction(actionName, args => args, () => ({
    loading: false,
    loader,
    message,
    stopLoading,
  }));
}

export function createAsyncAction(actionName, options = {}) {
  const loader = options.loader || actionName;

  const { message, globalLoading } = options;

  const name = actionName.toUpperCase();

  const INIT = startLoadingAction(`${name}_INIT`, loader, message, globalLoading);
  const DONE = endLoadingAction(`${name}_DONE`, loader, null, true);
  const FAILED = endLoadingAction(`${name}_FAILED`, loader, null, true);

  return {
    INIT,
    DONE,
    FAILED,
  };
}
